import React, { useState, useEffect, useCallback } from 'react';
import { Form, Row, Col, Modal } from 'antd';
import { LayoutWithoutAuth, Input, Button, Typography } from 'components';
import { useHistory, useParams } from 'react-router-dom';
import './forgot-password.less';
import { customMessages, customValidators } from 'utils';
import ERROR_MESSAGES from 'constants/error-messages.const';
import { CheckOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import * as loginService from 'services/login.service';

const { Title, Text } = Typography;

const errorList = [
  ERROR_MESSAGES.min(6),
  ERROR_MESSAGES.mustBigChar,
  ERROR_MESSAGES.mustLowChar,
  ERROR_MESSAGES.mustNumber,
];

const ForgotPasswordPage = () => {
  let history = useHistory();
  const [form] = Form.useForm();
  let { gsmNumber } = useParams();
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [newPasswordErrorFields, setNewPasswordErrorFields] = useState(
    errorList
  );
  const [formValues, setFormValues] = useState(null);
  useEffect(() => {
    return () => {};
  }, [formValues]);


  function onPasswordChange(values)
  {
    let data = values;
    data.msisdn = gsmNumber;
    loginService.passwordChange(data).then((result) => {
      history.push({
        pathname: `/Login`,
      });
    }).catch((err) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(err.responseCode),
      });
    });
  }

  return (
    <LayoutWithoutAuth className="forgot-password">
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center" className="forgot-password-box">
            <Col span={24} className="flex-center-center">
              <h1 className="section__title">Şifremi Unuttum</h1>
            </Col>
            <Col span={24} className="flex-center-center">
              <p className="info-text--big">Yeni şifrenizi belirleyin. Yeni şifre belirledikten sonra anasayfadan tekrar deneyebilirsiniz.</p>
            </Col>
            <Form
              form={form}
              style={{ width: '100%' }}
              name="forgotPassword"
              onValuesChange={(changedValues, allValues) => {
                setFormValues(allValues);
                form.validateFields().catch(({ errorFields }) => {
                  const newPasswordField = errorFields.find((i) =>
                    i.name.includes('newPassword')
                  );
                  setNewPasswordErrorFields(
                    newPasswordField && newPasswordField.errors
                      ? newPasswordField.errors
                      : []
                  );
                });
              }}
              onFinish={(values) => {
                onPasswordChange(values);
              }}
            >
              <Row className="password-newPassword-container">
                <Col span={24}>
                  <Form.Item
                    name="newPassword"
                    messageVariables={{ label: 'Şifre' }}
                    rules={[
                      {
                        validator: (rule, value) =>
                          customValidators.minLength(rule, value, 6),
                      },
                      {
                        validator: customValidators.hasBigChar,
                      },
                      {
                        validator: customValidators.hasLowChar,
                      },
                      {
                        validator: customValidators.hasNumber,
                      },
                    ]}
                  >
                    <Input.Password
                      autoComplete="off"
                      style={{ width: '100%' }}
                      placeholder="Yeni Şifrenizi Girin"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </Form.Item>
                  <div className="errors">
                    {errorList.map((item) => (
                      <Row key={item}>
                        <Col span={20}>
                          <span className="info-text">{item}</span>
                        </Col>
                        <Col>
                          {!newPasswordErrorFields.includes(item) && (
                            <CheckOutlined className="color-primary-4" />
                          )}
                        </Col>
                      </Row>
                    ))}
                  </div>
                </Col>
              </Row>
              <Row className="password-newPassword-container">
                <Col span={24}>
                  <Form.Item name="newPasswordRepeat">
                    <Input.Password
                      autoComplete="off"
                      style={{ width: '100%' }}
                      placeholder="Yeni Şifrenizi Tekrar Girin"
                    />
                  </Form.Item>
                  {newPasswordErrorFields.length === 0 &&
                  form.isFieldsTouched() &&
                  formValues.newPassword === formValues.newPasswordRepeat ? (
                    <div className="errors">
                      <span>Şifreyle Aynı</span>
                    </div>
                  ) : (
                    false
                  )}
                </Col>
              </Row>
              <Form.Item>
                <Form.Item>
                  <Row justify="center" gutter={30}>
                    <Col span={12}>
                      <Button type="ghost"   onClick={() => history.push('/ForgotPasswordPage')}>
                        Önceki Adım
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        shape="round"
                        disabled={
                          !(
                            newPasswordErrorFields.length === 0 &&
                            form.isFieldsTouched() &&
                            formValues.newPassword ===
                              formValues.newPasswordRepeat
                          )
                        }
                      >
                        Doğrula
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form.Item>
            </Form>
          </Row>
        </Col>
      </Row>
    </LayoutWithoutAuth>
  );
};
export default ForgotPasswordPage;
